// import { useState } from "react";
// import { CiSquarePlus } from "react-icons/ci";
// import { CiSquareMinus } from "react-icons/ci";
// import filterTreeAccordingToSearchTerm from "../utils/filterTreeAccordingToSearchTerm";

// export default function MenuComponent({ AllProduct, allcollapse, onLeafNodeClick, searchTerm = "" }) {
//   const [openMenus, setOpenMenus] = useState({});
//   const [selectedItemId, setSelectedItemId] = useState(null);

//   if (!AllProduct) return null;
//   // Toggle submenu open/close
//   const toggleMenu = (id) => {
//     setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   //apply serach filtering on all products
//   const filteredProducts = filterTreeAccordingToSearchTerm(AllProduct, searchTerm);
//   // console.log("filteredProducts", filteredProducts)

//   const handleLeafClick = (item) => {
//     setSelectedItemId(item.id);
//     onLeafNodeClick(item.name);
//   };

//   return (
//     <div className="menu">
//       <ul className="cursor-pointer">
//         {filteredProducts.map((menuItem, idx) => (
//           <MenuItem key={menuItem.id} item={menuItem} openMenus={openMenus} toggleMenu={toggleMenu} allcollapse={allcollapse} onLeafNodeClick={handleLeafClick}
//             selectedItemId={selectedItemId} />
//         ))}
//       </ul>
//     </div>
//   )
// }

// function MenuItem({ item, openMenus, toggleMenu, allcollapse, onLeafNodeClick, selectedItemId }) {
//   const isLeaf = !item.subMenu;

//   const handleClick = () => {
//     // console.log("clicked")
//     if (isLeaf) {
//       console.log("clicked on Item")
//       onLeafNodeClick(item); // Or item.id if needed
//     } else {
//       toggleMenu(item.id);
//     }
//   };
//   const isSelected = selectedItemId === item.id
//   return (
//     <li className="">
//       <div className={`menu-item ${isSelected ? "bg-slate-100/85 font-semibold" : ""}`} onClick={handleClick}>
//         {item.name} {!isLeaf && (<span className="icon">{openMenus[item.id] ? <CiSquareMinus /> : <CiSquarePlus />}</span>)}
//       </div>
//       {item.subMenu && openMenus[item.id] && (
//         <ul className="submenu cursor-pointer">
//           {item.subMenu.map((sub) => (
//             <MenuItem key={sub.id} item={sub} openMenus={openMenus} toggleMenu={toggleMenu} onLeafNodeClick={onLeafNodeClick} selectedItemId={selectedItemId} />
//           ))}
//         </ul>
//       )}
//     </li>
//   );
// }


import { useState, useEffect, useMemo } from "react";
import { CiSquarePlus } from "react-icons/ci";
import { CiSquareMinus } from "react-icons/ci";
import filterTreeAccordingToSearchTerm from "../utils/filterTreeAccordingToSearchTerm";

export default function MenuComponent({ AllProduct, FullProductTree, allcollapse, onLeafNodeClick, searchTerm = "" }) {
  const [openMenus, setOpenMenus] = useState({});
  const [selectedItemId, setSelectedItemId] = useState(null);

  // Apply search filtering on all products
  const dataSource = searchTerm?.trim() && FullProductTree ? FullProductTree : AllProduct;

  const filteredProducts = useMemo(() => {
    if (!dataSource) return [];
    return filterTreeAccordingToSearchTerm(dataSource, searchTerm);
  }, [dataSource, searchTerm]);

  // When searchTerm changes, auto-expand branches that the filtered tree contains
  useEffect(() => {
    const term = (searchTerm || "").trim();
    if (!term) {
      // Search cleared: collapse if allcollapse requested, otherwise keep user state
      if (allcollapse) setOpenMenus({});
      return;
    }

    // Build a map of IDs we want opened so filtered leaves are visible.
    const newOpen = {};
    const markAllBranches = (node) => {
      // If node has subMenu that contains matches, mark it open and recurse.
      if (node.subMenu && node.subMenu.length) {
        newOpen[node.id] = true;
        node.subMenu.forEach(markAllBranches);
      }
    };

    filteredProducts.forEach(markAllBranches);
    // Replace openMenus so we guarantee expansion to match results
    setOpenMenus(newOpen);
  }, [searchTerm, filteredProducts, allcollapse]);

  if (!AllProduct) return null;

  // Toggle submenu open/close (user action)
  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const isModelNode = searchTerm?.trim().length > 0

  const handleLeafClick = (item) => {
    console.log("what item id is", item)
    setSelectedItemId(item.id);
    onLeafNodeClick(
      {
        name: item.name,
        isLeaf: isModelNode,
        modelCode: item.modelCode ?? item.name,
      }
    );
  };

  return (
    <div className="menu" data-testid="product-tree-menu">
      <ul className="cursor-pointer">
        {filteredProducts.map((menuItem) => (
          <MenuItem
            key={menuItem.id}
            item={menuItem}
            openMenus={openMenus}
            toggleMenu={toggleMenu}
            allcollapse={allcollapse}
            onLeafNodeClick={handleLeafClick}
            selectedItemId={selectedItemId}
          />
        ))}
      </ul>
    </div>
  );
}

function MenuItem({ item, openMenus, toggleMenu, allcollapse, onLeafNodeClick, selectedItemId }) {
  const isLeaf = !item.subMenu;

  const handleClick = () => {
    // console.log("clicked")
    if (isLeaf) {
      console.log("clicked on Item")
      onLeafNodeClick(item); // Or item.id if needed
    } else {
      toggleMenu(item.id);
    }
  };
  const isSelected = selectedItemId === item.id
  return (
    <li className="">
      <div
        data-testid={`menu-item-${item.id}`}
        className={`menu-item ${isSelected ? "font-semibold" : ""}`}
        onClick={handleClick}
        style={isSelected ? { backgroundColor: '#EFF6FF', color: '#002FA7', borderLeft: '2px solid #002FA7', paddingLeft: '6px' } : {}}
      >
        {item.name} {!isLeaf && (<span className="icon" style={{ color: '#002FA7' }}>{openMenus[item.id] ? <CiSquareMinus /> : <CiSquarePlus />}</span>)}
      </div>
      {item.subMenu && openMenus[item.id] && (
        <ul className="submenu cursor-pointer">
          {item.subMenu.map((sub) => (
            <MenuItem key={sub.id} item={sub} openMenus={openMenus} toggleMenu={toggleMenu} onLeafNodeClick={onLeafNodeClick} selectedItemId={selectedItemId} />
          ))}
        </ul>
      )}
    </li>
  );
}
